import * as api from './generated/swagger'

api.OpenAPI.BASE = process.env.API_PATH

export * from './generated/swagger'
